export function initSliderWithVideo() {
    const carousels = document.querySelectorAll('[id^="kn_logo_textblock_slider_"]');
    
    carousels.forEach(carousel => {
        const videoWrappers = carousel.querySelectorAll('.kn_logo-textblock-slider__video-wrapper');
        
        videoWrappers.forEach(wrapper => {
            const video = wrapper.querySelector('video');
            
            // Play video if it's in active slide initially
            if (wrapper.closest('.carousel-item').classList.contains('active')) {
                video.play();
            }
            
            // Video Ende Handler
            video.addEventListener('ended', () => {
                video.currentTime = 0;
                video.play(); // Loop video
            });
        });

        // Handle slide transitions
        carousel.addEventListener('slide.bs.carousel', () => {
            const allVideos = carousel.querySelectorAll('video');
            allVideos.forEach(video => {
                video.pause();
                video.currentTime = 0;
            });
        });

        carousel.addEventListener('slid.bs.carousel', (event) => {
            const activeSlide = carousel.querySelector('.carousel-item.active');
            const activeVideo = activeSlide.querySelector('video');
            if (activeVideo) {
                activeVideo.play();
            }
        });
    });
}